'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            show_help: false
        };
    },
    computed: {
        aliasText: {
            get: function getAliasText() {
                return _state2.default.setting('aliases').trim();
            },
            set: function setAliasText(newVal) {
                _state2.default.setting('aliases', newVal.trim());
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SettingsAliases"]
window._kiwi_exports.components.SettingsAliases = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SettingsAliases.vue
// module id = bhyE
// module chunks = 1